import { call, put, takeLatest } from 'redux-saga/effects';
import handleException from '../services/handleException';
import { getListCountry } from '../utils/getListCountry';
import { GET_LIST_COUNTRY, GET_LIST_COUNTRY_SUCCESS } from './../actions/getListCountry';

function* getlistCountrySaga() {
    yield takeLatest(GET_LIST_COUNTRY, getListCountryHandle)
}

function* getListCountryHandle(action) {
    try {
        const response = yield call(getListCountry, action.payload)

        if (response.data.code === 200) {
            yield put({ type: GET_LIST_COUNTRY_SUCCESS, payload: response })
        } else {
            handleException(response)
        }
    } catch (error) {
        handleException(error)
    }
}

export default getlistCountrySaga


// WEBPACK FOOTER //
// ./src/sagas/getListCountrySaga.js